module.exports = __webpack_public_path__ + "eceff26a5f33cc81123f437a16a78dbe.svg";